import "./hero.css";
import heroSmall from "../../../../assets/img/banners/hero_small.webp";
import heroMedium from "../../../../assets/img/banners/hero_medium.webp";
import heroLarge from "../../../../assets/img/banners/hero_large.webp";
import { Parallax } from 'react-parallax';
import { HashLink } from 'react-router-hash-link';
import equitrackBrochure from "../../../../assets/documents/equi-track-overview-october-2026.pdf"


export default function Hero() {
    return (
        <Parallax
            bgImage={heroLarge}
            bgImageAlt="Hero Image: Tracking assets and vehicles"
            strength={300}
            bgImageSrcSet={`${ heroSmall } 500w, ${ heroMedium } 1000w, ${ heroLarge } 2560w`}
        >
            {/* ^ Smaller resolutions: https://stackoverflow.com/questions/28650327/responsive-images-srcset-not-working seems to be fixed. */}
            <div id="hero">
                <div className="card-holder">
                    <div className="card px-4 py-4 px-md-5 px-lg-3 py-lg-2">
                        <div className="card-body text-center text-sm text-white">
                            { /* Hero Title & Introduction */}
                            <h1 className="card-title text-white display-6 mb-4">Your equipment, maintenance and stock. All together.</h1>
                            <p className="hero-intro fw-light p-1 mb-4">equi-track brings equipment, tools, parts, stock and maintenance into one cloud-based system - helping your team stay organised, find information quickly and spend less time on admin.</p>
                            <div className="d-flex flex-wrap gap-3 align-items-center justify-content-center py-2 pb-lg-0">
                                <HashLink smooth to="/#contact" className="btn btn-lg btn-light">Book a demonstration</HashLink>
                                <a target="_blank" rel="noreferrer" href={equitrackBrochure} className="btn btn-lg btn-outline-light brochure-btn">Download our brochure</a>
                            </div>
                            <p className="hero-demo-note mt-3 mb-0">See how equi-track could work for your business. Choose a TEAMS demonstration or tell us if you'd prefer to meet in person.</p>
                        </div>
                    </div>
                </div>
            </div>
        </Parallax>
    );
}
